module.exports = __webpack_public_path__ + "img/marketing.39f2d764.png";